export default __webpack_public_path__ + "static/media/exam.d8bd44ef.png";